
import { useAccountsData } from "./accounts/useAccountsData";
import { useCreateAccount } from "./accounts/useCreateAccount";
import { useUpdateAccount } from "./accounts/useUpdateAccount";
import { useDeleteAccount } from "./accounts/useDeleteAccount";
import { useAccountStatus } from "./accounts/useAccountStatus";
import { Account } from "@/types/strategy-types";

export const useAdminAccounts = (providerId?: string | null) => {
  const { accounts, loading, loadAccounts } = useAccountsData(providerId);
  const { createAccount } = useCreateAccount(loadAccounts);
  const { updateAccount } = useUpdateAccount(loadAccounts);
  const { deleteAccount } = useDeleteAccount(loadAccounts);
  const { toggleAccountActive } = useAccountStatus(loadAccounts);

  return { 
    accounts, 
    loading, 
    loadAccounts, 
    createAccount,
    updateAccount,
    deleteAccount,
    toggleAccountActive
  };
};
